import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

const Protected_Routes = (props) => {
    const navigate = useNavigate();
    const { Component } = props
    const is_user_active = localStorage.getItem("is_user_active");

    useEffect(() => {
        if (!is_user_active) {
            navigate("/login")
        }
    })
    return (
        <div><Component /></div>
    )
}

export default Protected_Routes
